class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();
    this.currentProductHandle = this.getAttribute('current-product-handle');
    this.parentSection = this.closest('section');
    this.slider = this.querySelector('embla-carousel');
  }

  MAX_PRODUCT_COUNT = 4;

  connectedCallback() {
    this.recentlyViewedProducts = JSON.parse(localStorage.getItem('recentlyViewedProducts')) || [];
    if (this.recentlyViewedProducts.length === 0 || (
      this.recentlyViewedProducts.length === 1 && 
      this.recentlyViewedProducts[0] === this.currentProductHandle)
    ) {
      this.parentSection.classList.add('hidden');
      this.parentSection.classList.add('!hidden');
      return;
    }
    const filteredRecentlyViewedProducts = this.recentlyViewedProducts.filter((productHandle) => productHandle !== this.currentProductHandle);
    filteredRecentlyViewedProducts.forEach((productHandle, index) => {
      const request = new XMLHttpRequest();
      request.addEventListener('load', this.handleModalResponse.bind(this, index));
      request.open('GET', `${window.Shopify.routes.root}products/${productHandle}?sections=product-card`, true);
      request.send();
    });

    // if product count is less than 4, remove the excess divs
    if (this.recentlyViewedProducts.length < this.MAX_PRODUCT_COUNT) {
      const excessCount = this.MAX_PRODUCT_COUNT - this.recentlyViewedProducts.length;
      for (let i = 0; i < excessCount; i++) {
        const productCardContainer = this.querySelector(`#recently-viewed-product-${this.recentlyViewedProducts.length + i + 1}`);
        productCardContainer.remove();
      }
    }
  }

  handleModalResponse(index, event) {
    const productCardContent = JSON.parse(event.target.response)['product-card'];
    const html = new DOMParser().parseFromString(productCardContent, 'text/html');
    const productCard = html.querySelector('#product-card-section');
    const productCardContainer = this.querySelector(`#recently-viewed-product-${index + 1}`);
    productCardContainer.innerHTML = productCard.innerHTML;
  }
}

customElements.define('recently-viewed-products', RecentlyViewedProducts);